<template>
    <div v-if="user.role == 1001 || user.role == 1002 || user.role == '056' || user.role == '059' || user.role == '016'   || user.role === '11705' || user.role === '11716'">
<b-dropdown right split split-variant="light" variant="light" size="lg" class="dd float-right ml-5">
        <template #button-content>
        <span v-if="depName != 'chofer-local'" class="drop-text">Departamento:  <span> {{depName}}</span></span>
        <span v-else class="drop-text">Departamento:  <span>chofer local</span></span>
        </template>
        <b-dropdown-item v-for="(item, index) in departments" :key="item.id" 
         @click="activate(index); CHANGE_DEPTO(item.nombre); changeDeptos(item.nombre, cityName); getProduccion({'cityName': cityName, 'depName': depName}); getBonos({'cityName': cityName, 'depName': depName})" 
         :class="['stylingSmall',{ 'active' : element == index }]">
            {{item.nombre}}
        </b-dropdown-item>
    </b-dropdown> 
    </div >
    <div  v-else>
<b-dropdown right split split-variant="light" variant="light" size="lg" class="dd float-right">
        <template #button-content>
        <span v-if="depName != 'chofer-local'" class="drop-text">Departamento:  <span> {{depName}}</span></span>
        <span v-else class="drop-text">Departamento:  <span>chofer local</span></span>
        </template>
        <b-dropdown-item v-for="(item, index) in departments" :key="item.id" 
         @click="activate(index); CHANGE_DEPTO(item.nombre); changeDeptos(item.nombre, cityName); getProduccion({'cityName': cityName, 'depName': depName}); getBonos({'cityName': cityName, 'depName': depName})" 
         :class="['stylingSmall',{ 'active' : element == index }]">
            {{item.nombre}}
        </b-dropdown-item>
    </b-dropdown> 
    </div>
    
</template>

<script>
import {mapMutations, mapActions} from 'vuex';

export default {
    name: 'Dropdown',
    props:{
        departments: {
            required: true
        }
    },
    data() {
        return {
            element: 0
        }
    },
    computed:{
        depName() {
            return this.$store.getters["admin/getDep"];
        },
        cityName(){
            return this.$store.getters['admin/getName'];
        },
         user() {
        return this.$store.getters['userService/getIdentity'];
        },
    },
    methods:{
        ...mapMutations('admin', ['CHANGE_DEPTO']),
        ...mapActions('plants', ['getBonos']),
        ...mapActions('plants', ['getProduccion']),
        activate: function(index){
            this.element = index;
        },
        changeDeptos: function(depto, city){                                    
            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
            this.$store.dispatch("plants/getAllInfo", {
                department: depto,
                city: nCity
            }); 
            this.$store.dispatch("plants/getBDInfo", {
                department: depto,
                city: nCity
            }); 
        }  
    }
}
</script>

<style scoped>
.dd >>> button{
    background-color: white;
    border: none;
    font-family: 'FuturaPTDemi';
    font-size: 16px;
    color: #919191;

}
.dd >>> li.active, .dd >>> li.active a:hover, .dd >>> li a:hover{
    background-color: #fd832d;
    color: white;
}
.dd >>> li.active a{
    color: white;;
}
.dd >>> li a{
    color: #808080;;
}
.drop-text span{
    color: #005cc3;
    text-decoration: underline;
}
</style>